module.exports = __webpack_public_path__ + "static/media/qr-walink-eafit-2.32a2206a.jpg";